/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-computed-property-dependencies, ember/require-tagless-components */
import Component from '@ember/component';
import { cached } from '@glimmer/tracking';
import Judgement from '@linc-technologies/linced-common/enums/progression-judgement';
import { computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import {
  findBy,
  mapBy,
  resolved,
} from '@linc-technologies/linced-common/utils/arrays';

export default class GoalsProgress extends Component {
  Judgement = Judgement;

  // Props
  // categories provides all school goal categories to generate goal progress
  // reports for. Callers give a plain array, a record array or an async
  // hasMany (report/print-subject gives subject.categories).
  categories = null;

  // person provides the person to generate goal progress reports for.
  person = null;

  // subjectData provides the subject data to generate a goal progress chart
  // for.
  subjectData = null;

  // school provides the school to find options in order to generate goal
  // progress reports.
  school = null;

  // showCurrentGoalProgress specifies whether the goal list should show the
  // student's current progress.
  showCurrentGoalProgress = false;

  width = 100;
  height = 100;
  thickness = 28;
  smallLabel = false;

  // Methods
  // categoryList is the loaded categories as an array, for each type of
  // categories that callers give. It is empty until a hasMany loads.
  get categoryList() {
    return resolved(this.categories);
  }

  // showCategories filters the received categories down to categories that
  // contain data. It is @cached, not @computed with dependent keys: @cached
  // tracks what it reads, so it is computed again when a hasMany of
  // categories loads.
  @cached
  get showCategories() {
    let categorySummaryData = [];
    let categories = this.get('subjectData.summary.categories');
    if (isEmpty(categories)) {
      return categorySummaryData;
    }

    let categoryIds = mapBy(categories, 'categoryId');
    let modelCategories = this.categoryList
      .slice()
      .sort(
        (a, b) =>
          a.sequence - b.sequence ||
          (a.label || '').localeCompare(b.label || ''),
      )
      .filter((item) => {
        return categoryIds.includes(item.id);
      });

    modelCategories.forEach(function (modelCategory) {
      let categorySummary = findBy(categories, 'categoryId', modelCategory.id);
      if (isEmpty(categorySummary)) {
        return;
      }

      if (categorySummary.totalGoals === categorySummary.notSet) {
        // If no progress has been made, discard showing the category.
        return;
      }

      categorySummaryData.push(categorySummary);
    });

    return categorySummaryData;
  }

  // expectedCategory returns the category the student is expected to be at,
  // based on the category linked to the level they are working at.
  @computed('subjectData.summary')
  get expectedCategory() {
    return this.get('subjectData.expected.goalCategory');
  }
}
